import { render, staticRenderFns } from "./InkjetPrintingPrice.vue?vue&type=template&id=b01c6760&"
import script from "./InkjetPrintingPrice.ts?vue&type=script&lang=js&"
export * from "./InkjetPrintingPrice.ts?vue&type=script&lang=js&"
import style0 from "./InkjetPrintingPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports